import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NotificationContent } from 'projects/shared/constants/notifications/notification-content';
import { NotificationTitle } from 'projects/shared/constants/notifications/notification-message';
import {
  InviteUsersRequest,
  DeleteUsersRequest,
  UpdateBulkUsersResponse,
  InviteBulkUsersResponse,
} from 'projects/shared/services/inspection-companies/inspection-company.user.service';
import { UserWithRolesResponse } from 'projects/shared/services/inspection-companies/models/users/user-with-roles.response';
import { UsersDeletedResponse } from 'projects/shared/services/inspection-companies/models/users/users-deleted-response';
import { ReinvitePendingUsersModel } from 'projects/shared/services/invitations/models/reinvite-pending-users.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { FilterCriteria } from './FilterCriteria';
import { RoleResponse } from 'projects/shared/services/roles/models/role.response';
import { Permission } from '../../directives/if-permission.directive';

@Component({
  selector: 'shared-list-users-toolbar',
  standalone: false,
  styles: [],
  template: `<div class="flex justify-between flex-wrap gap-1rem">
    <shared-list-users-filter [filterCriteria$]="filterCriteria$" [roles$]="roles$" />
    <div class="flex">
      <shared-invite-users-button
        [roles$]="roles$"
        (userInvited)="onUserInvited()"
        [(isVisible)]="inviteUserModalVisible"
        [inviteUsersAction]="inviteUsersAction"
        [bulkInviteUsersAction]="bulkInviteUsersAction" />
      <shared-bulk-user-actions-button
        [selectedUsers]="selectedUsers"
        [deleteUsersAction]="deleteUsersAction"
        [reinvitePendingUsersAction]="reinvitePendingUsersAction"
        [bulkUpdateUsersAction]="bulkUpdateUsersAction"
        (usersReinvited)="onUsersReinvited($event)"
        (usersDeleted)="usersDeleted.emit($event)"
        (bulkUsersUpdated)="bulkUsersUpdated.emit($event)" />
    </div>
  </div>`,
})
export class ListUsersToolbarComponent {
  @Input({ required: true }) filterCriteria$: BehaviorSubject<FilterCriteria>;
  @Input({ required: true }) roles$: Observable<RoleResponse[]>;
  @Input() selectedUsers: Set<UserWithRolesResponse> = new Set<UserWithRolesResponse>();
  @Input() inviteUsersAction: (model: InviteUsersRequest[]) => Observable<UserWithRolesResponse[]>;
  @Input() reinvitePendingUsersAction: (model: ReinvitePendingUsersModel) => Observable<void>;
  @Input() deleteUsersAction: (model: DeleteUsersRequest) => Observable<UsersDeletedResponse>;
  @Input() bulkUpdateUsersAction: (file: File) => Observable<UpdateBulkUsersResponse>;
  @Input() bulkInviteUsersAction: (file: File) => Observable<InviteBulkUsersResponse>;

  @Output() userInvited = new EventEmitter<void>();
  @Output() usersReinvited = new EventEmitter<void>();
  @Output() usersDeleted = new EventEmitter<boolean>();
  @Output() bulkUsersUpdated = new EventEmitter<void>();

  inviteUserModalVisible = false;

  constructor(private notificationService: NzNotificationService) {}

  onUserInvited() {
    this.userInvited.emit();
  }

  onUsersReinvited(errorMessage: string | undefined) {
    if (errorMessage) {
      this.notificationService.error(NotificationTitle.Error, errorMessage || NotificationContent.DefaultError, {
        nzDuration: 0,
      });
    } else {
      this.userInvited.emit();
    }
  }
}
